<template>
    <div id="index">
        <div class="visible-xs">
            <div class="head_div flex_between">
                <i @click.stop="returnFun">
                    <img src="@/assets/img/esc_fan.png" alt="">
                </i>
                <span @click.stop="goLogin">登录</span>
            </div>
            <div class="logo_div">
                <h4 class="title">注册</h4>
                <div class="user_num" :class='{"value":phone !== ""}'>
                    <input type="Number" @focus="is_keyboard = true" @blur="is_keyboard = false" v-model="phone"
                        placeholder="请输入手机号">
                </div>
                
                <div class="user_num password_li" :class='{"value":password !== ""}'>
                    <input type="password" @focus="is_keyboard = true" @blur="is_keyboard = false" v-model="password"
                        placeholder="请输入密码">
                </div>
                <div class="user_num password_li" :class='{"value":confirmPassword !== ""}'>
                    <input type="password" @focus="is_keyboard = true" @blur="is_keyboard = false"
                        v-model="confirmPassword" placeholder="再次输入密码">
                </div>
                <div class="user_num password_li" :class='{"value":invitation !== ""}'>
                    <input type="text" @focus="is_keyboard = true" @blur="is_keyboard = false" v-model="invitation"
                        placeholder="会员邀请码（选填）">
                </div>
                <button class="login" @click="login">下一步</button>
                <div class="flex_center prompt">
                    注册即表示接受
                    <span @click.stop="user_agreement">【用户协议】</span> <span @click.stop="privacy">【隐私保护】</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import "@/assets/js/swiper.animate1.0.3.min.js";
    import "@/assets/css/animate.min.css";
    import "@/assets/css/video-js.min.css";

    export default {
        name: "index",
        data() {
            return {
                IMG_URL: this.$IMG_URL,
                is_keyboard: false,//是否打开键盘
                cert:'',
                URL: this.$URL,
                phone: '15680615712',//手机
                password: '',//密码
                confirmPassword: '',//确认密码
                invitation: '',//邀请码
            };
        },
        computed: {},
        components: {

        },
        watch: {
            phone: function (eve) {
                this.$store.commit('setPhone', eve)
            },
        },
        methods: {
            privacy() {//隐私权
                this.$router.push('/privacy');
            },
            user_agreement() {//用户协议
                this.$router.push('/user_agreement');

            },
            goLogin() {//登录
                this.$router.replace({ path: '/m_password', query: { } });
            },
            returnFun() {//返回上一页
                if (this.$store.state.query_url) {
                    this.$router.replace({ path: this.$store.state.query_url });
                } else {
                    this.$router.go(-1);
                }
            },
            validation() {//验证信息
                if (this.phone == '' || !this.phone) {
                    layer.open({
                        content: "请输入手机号",
                        time: true,
                        skin: "msg"
                    });
                    return false;
                }
            
                if (this.phone.length !== 11) {
                    layer.open({
                        content: "手机号不为11位",
                        time: true,
                        skin: "msg"
                    });
                    return false;
                }
                if (!this.validationPhone(this.phone)) {
                    layer.open({
                        content: "手机号格式错误",
                        time: true,
                        skin: "msg"
                    });
                    return false;
                }
                if (this.password == '' || !this.password || this.password.length < 6) {
                    layer.open({
                        content: "请输入六位数密码",
                        time: true,
                        skin: "msg"
                    });
                    return false;
                }
                if (this.confirmPassword == '' || !this.confirmPassword) {
                    layer.open({
                        content: "请确认密码",
                        time: true,
                        skin: "msg"
                    });
                    return false;
                }
                if (this.confirmPassword !== this.password) {
                    layer.open({
                        content: "两次密码不一致",
                        time: true,
                        skin: "msg"
                    });
                    return false;
                }
                return true
            },
            login() {
                if (!this.validation()) {
                    return false;
                }
                this.$store.commit('setBasic',this.USER())
                this.$store.commit('setPassword', this.password)
                this.$store.commit('setInvitation', this.invitation)
                this.$router.push({ path: '/m_information', query: { type: 2} });
            },
            // 判断完毕后加载样式
            setActiveStyleSheet(filename) {
                document.write("<link href=" + filename + " rel=stylesheet>");
            },

        },
        activated(){
             console.log( this.$store.state.phone,'phone');
            this.phone = this.$store.state.phone;
        },
        mounted() {
            let that = this;
            console.log( this.$store.state.phone,'phone');
            this.phone = this.$store.state.phone;
            this.invitation = this.$store.state.invitation;
            this.getShare();
            if (this._isMobile()) {
                // alert("手机端");
                //   this.$router.replace('/m_index');
            } else {
                // alert("pc端");
                this.$router.replace("/");
            }


            // window.onload = function () {
            //     var w = document.body.clientWidth; //获取屏幕宽度
            //     // 这里*100 是为了取整数
            //     var x = parseInt((w * 100) / 375 * 10) / 10; //获取任意屏幕上的根节点字体大小
            //     document.getElementsByTagName('html')[0].style.fontSize = x + 'px';
            //     //监听屏幕宽度变化
            //     window.onresize = function () {
            //         var w = document.body.clientWidth; //获取屏幕宽度
            //         var x = parseInt((w * 100) / 375 * 10) / 10;; //获取任意屏幕上的根节点字体大小
            //         document.getElementsByTagName('html')[0].style.fontSize = x + 'px';
            //     }
            // }
        }
    };
</script>

<style scoped>
    html,
    body {
        max-width: 100vw;
    }

    .visible-xs {
        width: calc(100% - 4.8rem);
        overflow: hidden;
        padding-top: 0rem;
        padding: 1.6rem 2.4rem;
    }

    .head_div>span {
        font-size: 1.3rem;
        color: #333;
    }

    .head_div>i {
        width: 1.8rem;
    }

    .logo_div {
        position: fixed;
        top: 8vh;
        left: 50%;
        transform: translateX(-50%);
        width: calc(100vw - 4rem);
    }

    .title {
        margin-top: 5rem;
        font-size: 2rem;
        color: 333;
        font-weight: bold;
    }

    .user_num {
        border-bottom: .05rem solid #EFEFEF;
        margin-top: 5.8rem;
    }

    .user_num>input {
        width: 100%;
        height: 4rem;
        font-size: 1.3rem;
        line-height: 4rem;
    }

    .user_num.value {
        border-color: #F24D5B;
    }

    .password_li {
        margin-top: 2.7rem;
    }

    .forget_div {
        margin-top: 1rem;
    }

    .forget_div .forget {
        font-size: 1.2rem;
        color: #666;
    }

    .login {
        width: 100%;
        margin-top: 6vh;
        height: 4.5rem;
        border-radius: 2.2rem;
        background: #F24D5B;
        color: #fff;
        border: 0;
        font-size: 1.8rem;
        box-shadow: 0 0 2.7rem rgba(241, 77, 91, 0.3);
    }

    .prompt {
        margin-top: 3.7rem;
        font-size: 1.3rem;
        color: #999999
    }

    .prompt>span {
        color: #F14D5B;
        margin-left: .4rem;
    }

    .wx_logo {
        position: fixed;
        bottom: 3rem;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
    }

    .wx_logo .wx_text {
        font-size: 1.2rem;
        color: #BABFC0;
        position: relative;
    }

    .wx_logo .wx_text::after {
        content: '';
        position: absolute;
        left: -10rem;
        top: 50%;
        transform: translateY(-50%);
        width: 8.8rem;
        height: .05rem;
        background: #DFDFDF;
    }

    .wx_logo .wx_text::before {
        content: '';
        position: absolute;
        right: -10rem;
        top: 50%;
        transform: translateY(50%);
        width: 8.8rem;
        height: .05rem;
        background: #DFDFDF;
    }

    .wx_logo>i {
        width: 4rem;
        margin: 1.7rem auto 0 auto;

    }

    .visible-xs {
        width: calc(100% - 4.8rem);
        overflow: hidden;
        padding-top: 0rem;
        padding: 1.6rem 2.4rem 15rem 2.4rem;
        min-height: calc(100vh - 16.6rem);
    }

    .logo_div {
        position: relative;
        top: 0;
        left: 0;
        transform: translateX(0);
        margin-top: .25rem;
        width: calc(100vw - 4rem);
    }

    .wx_logo {
        position: absolute;
        bottom: 3rem;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/minLogin/m_registered.vue